import TextField from "@mui/material/TextField";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormController } from "../../FormController/FormController";

export const ProjectDescriptionField = ({ control, disabled }) => {
  const { t } = useTranslation();

  return (
    <FormController
      control={control}
      name="description"
      required
      label={t("project.description")}
      render={({ field, fieldState, label }) => (
        <TextField
          error={fieldState.invalid}
          fullWidth
          inputProps={{ maxLength: 255 }}
          label={label + " *"}
          {...field}
          disabled={disabled}
        />
      )}
    />
  );
};
